export default "__VITE_PUBLIC_ASSET__2a4fec47__"